import { GridModel } from "common/models/utility-models/list-utility.model";
import { PlacementReportsModel } from "./placement-report-data.model";

export class PlacementReportsGridModel extends PlacementReportsModel { }

export class PlacementReportsListingModel extends GridModel<PlacementReportsModel> {
    filterData: any;
}